module.exports = __webpack_public_path__ + "static/media/portrait4.14bcba07.jpg";